export enum PaymentServiceType {
  None = 0,
  CardConnect = 1,
  Cornerstone = 2,
  PayPal = 3,
  Bitcoin = 4,
  CornerstoneImport = 5,
  Stripe = 6
}
